module.exports = __webpack_public_path__ + "img/service1.0739ca88.jpg";